/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package api.model

data class AuthCredentials(
    val username: String = "",
    val password: String = ""
)